module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("“. . . and leave you, (inexpressibly to unravel)"), _c('br'), _vm._v("\n    your life, with its immensity and fear,"), _c('br'), _vm._v("\n    so that, now bounded, now immeasurable,"), _c('br'), _vm._v("\n    it is alternately stone in you and star.”")]), _vm._v(" "), _c('p', {
    staticClass: "att_left"
  }, [_vm._v("Rainer Maria Rilke"), _c('br'), _vm._v("\n    translated by Stephen Mitchell"), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4d6ff54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02_fm02.vue
// module id = 69
// module chunks = 0